/*
         * @ngdoc function
         * @name ePay.Model:Session_AgencyModel
         * @description
         * Model
         */

export class Session_AgencyModel {
  returnPage: string | null | undefined;
  page: string | null | undefined;
  type: string | null | undefined;
  amount: number | null | undefined;
  name: string | null | undefined;
  agencyName: string | null | undefined;
  costRange: string | null | undefined;
  customPage: boolean | null | undefined;
  paymentMode: string | null | undefined;
  domainName: string | null | undefined;
  payThroughFromDate: Date | null | undefined;
  payThroughToDate: Date | null | undefined;
  css: string | null | undefined;
  agency: string | null | undefined;
  confirmationPage: boolean | null | undefined;
  email: boolean | null | undefined;
  store: boolean | null | undefined;
  tempAuthorize: boolean | null | undefined;

  constructor(
    returnPage?: string,
    page?: string,
    type?: string,
    amount?: number,
    name?: string,
    agencyName?: string,
    costRange?: string,
    customPage?: boolean,
    paymentMode?: string,
    domainName?: string,
    payThroughFromDate?: Date,
    payThroughToDate?: Date,
    css?: string,
    agency?: string,
    confirmationPage?: boolean,
    email?: boolean,
    store?: boolean,
    tempAuthorize?: boolean
  ) {
    this.returnPage = returnPage || null;
    this.page = page || null;
    this.type = type || null;
    this.amount = amount || null;
    this.name = name || null;
    this.agencyName = agencyName || null;
    this.costRange = costRange || null;
    this.customPage = customPage || null;
    this.paymentMode = paymentMode || null;
    this.domainName = domainName || null;
    this.payThroughFromDate = payThroughFromDate || null;
    this.payThroughToDate = payThroughToDate || null;
    this.css = css || null;
    this.agency = agency || null;
    this.confirmationPage = confirmationPage || null;
    this.email = email || null;
    this.store = store || null;
    this.tempAuthorize = tempAuthorize || null;
  }
}
